import React from "react";
import DynamicWizard from "../../../components/crud/DynamicWizard";
import { studentRefundWizardConfig } from "./config";
import {useParams} from "react-router-dom";

const StudentRefundRequest = () => {
  const params = useParams();
  return (
    <div>
      <DynamicWizard
        config={studentRefundWizardConfig}
        onFinished={() => {}}
        recordId={90}
        params={params}
      />
    </div>
  );
};

export default StudentRefundRequest;